/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import Api from "src/util/api";
import {PageDo} from "src/types/base";
export declare namespace AlarmQueryDOI {

	export interface RowDataI {
        id: number
        alarm_data : string
        create_time : string
        mn     : string
	}

	export interface QueryRowDataParamsI extends PageDo {
        start_time     : string,
        end_time     : string,
	}


}
export default class AlarmQueryApi {
    /**
     * 湖南设备报警查询
     * @param params
     */
    static async listAlarmPage(params: any) {
        return Api.post('/monitor/hunan/device/alarm/query', params)
    }
}
